import { cn } from "@lib/utils/helpers";
import { CreditReportHtmlSection } from "../credit/CreditReportHtmlSection";
import type { CreditReportBureauActionsSectionProps } from "../../types";

export function CreditReportBureauActionsSection({
  tab,
}: CreditReportBureauActionsSectionProps) {
  const {
    creditReportHtmlIframeRevision,
    handleOpenCreditReport,
    htmlReportUrl,
    openCreditReportDisabled,
    openCreditReportTooltip,
    openingReport,
    processing,
    showAngularHtmlIframe,
    showCreditReportBureauActions,
    showOpenCreditReportButton,
    showStepperResubmit,
    stepperResubmitHandler,
    stepperResubmitLabel,
  } = tab;

  if (!showCreditReportBureauActions) {
    return null;
  }

  const bureauActions = {
    showResubmit: showStepperResubmit,
    resubmitLabel: stepperResubmitLabel,
    onResubmit: stepperResubmitHandler,
    resubmitDisabled: processing,
    showOpen: showOpenCreditReportButton,
    onOpenCreditReport: () => void handleOpenCreditReport(),
    openCreditReportDisabled,
    openCreditReportTooltip,
    openingReport,
  };

  if (showAngularHtmlIframe && htmlReportUrl) {
    return (
      <CreditReportHtmlSection
        htmlReportUrl={htmlReportUrl}
        iframeRevision={creditReportHtmlIframeRevision}
        bureauActions={bureauActions}
      />
    );
  }

  if (!showStepperResubmit && !showOpenCreditReportButton) {
    return null;
  }

  const buttonClass = cn(
    "rounded-md bg-[#0d6efd] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors",
    "hover:bg-[#0b5ed7] disabled:cursor-not-allowed disabled:opacity-50",
  );

  return (
    <div className="mb-6 mt-4 flex flex-wrap items-center justify-end gap-2" data-testid="application-credit-report-tab-section-actions">
      {showOpenCreditReportButton ? (
        <button
          type="button"
          data-testid="application-credit-report-tab-open-credit-report-button"
          className={buttonClass}
          onClick={() => void handleOpenCreditReport()}
          disabled={openCreditReportDisabled}
          title={openCreditReportTooltip}
        >
          {openingReport ? "Working…" : "Open Credit Report"}
        </button>
      ) : null}
      {showStepperResubmit ? (
        <button
          type="button"
          data-testid="application-credit-report-tab-resubmit-credit-report-button"
          className={buttonClass}
          onClick={stepperResubmitHandler}
          disabled={processing}
        >
          {stepperResubmitLabel}
        </button>
      ) : null}
    </div>
  );
}
